import { ActivityCard } from '@/features/activity/components/activity-card';
import { useAppTheme } from '@/providers/theme-provider';
import type { FeedItem } from '@/types/feed';
import Ionicons from '@expo/vector-icons/Ionicons';
import React from 'react';
import { ActivityIndicator, Pressable, Text, View } from 'react-native';

interface ProfileFeedProps {
  items: FeedItem[];
  isLoading: boolean;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  onLoadMore: () => void;
  onLike?: (checkInId: string, currentlyLiked: boolean) => void;
}

export function ProfileFeed({
  items,
  isLoading,
  hasNextPage,
  isFetchingNextPage,
  onLoadMore,
  onLike,
}: ProfileFeedProps) {
  const theme = useAppTheme();
  return (
    <View>
      {isLoading && (
        <View className="py-8 items-center">
          <ActivityIndicator color={theme.colors.primary} />
        </View>
      )}

      {!isLoading && items.length === 0 && (
        <View className="items-center py-8">
          <View className="w-16 h-16 rounded-full items-center justify-center mb-4 bg-surface-secondary">
            <Ionicons
              name="restaurant-outline"
              size={28}
              className="text-muted-foreground"
            />
          </View>
          <Text className="text-center text-muted-foreground">
            No check-ins yet
          </Text>
        </View>
      )}

      {!isLoading && items.length > 0 && (
        <View>
          {items.map((feedItem) => (
            <ActivityCard key={feedItem.checkIn.id} item={feedItem} onLike={onLike} />
          ))}
          {hasNextPage && (
            <View className="py-4 items-center">
              {isFetchingNextPage ? (
                <ActivityIndicator color={theme.colors.primary} />
              ) : (
                <Pressable
                  onPress={onLoadMore}
                  className="px-6 py-3 rounded-lg bg-surface-secondary"
                >
                  <Text className="font-semibold text-foreground">
                    Load more
                  </Text>
                </Pressable>
              )}
            </View>
          )}
        </View>
      )}
    </View>
  );
}
